
















































import { Component, Prop } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import CreatePaymentOrderRequest from '@/models/Accounts/Shared/PaymentOrders/CreatePaymentOrderRequest';
import Payee from '@/models/Accounts/Shared/Payees/Payee';

@Component({ name: 'PaymentOrderSummary' })
export default class extends SaascadaVueDialog {

    @Prop({required: true})
    request: CreatePaymentOrderRequest;

    @Prop({required: true})
    selectedPayee: Payee;

    @Prop({required: true})
    expiresAtDateAsString: string;

    @Prop({required: true})
    todaysDateAsString: string;

    changeExpiresAtDate(date: string) {
        this.$emit('inputDate', date);
    }

}
